<div class="table-header-row" *ngIf="parentCommands">
  <div class="table-header-row__options">
    <ng-content></ng-content>
  </div>
  <span class="toolbar">
    <miq-commands
      [resources]="selectedResources"
      [commands]="parentCommands"
      [errorCallback]="notify"
      (namedEvent)="handleInternalEvent($event, selectedResources)"
    ></miq-commands>
  </span>
</div>

<div class="detailcomplextable-layout">
  <p-table
    miqStopKeydown
    [columns]="parentColumns"
    [value]="elements | hideFlaggedItems: hideElements"
    [selection]="selectedResources"
    columnResizeMode="expand"
    class="records-table"
    [paginator]="inMemoryPaginator"
    [(rows)]="rows"
    [rowsPerPageOptions]="rowsPerPageOptions"
    paginatorDropdownAppendTo="body"
    [showCurrentPageReport]="showCurrentPageReport"
    [reorderableColumns]="false"
    [customSort]="customSort"
    [sortField]="_sortOptions?.sortField"
    [sortOrder]="_sortOptions?.sortOrder"
    class="{{ 'icon-size__x' + iconColumnSize }}"
    [ngClass]="{
      'complex-table-parent-select-column-additonalWidth': selectable && showGoToRecordColumn,
    }"
    (selectionChange)="selectedResourcesChange.emit($event)"
    (sortFunction)="emitSort($event)"
    (onRowReorder)="handleRowReorder($event)"
    (onPage)="onPage.emit($event)"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <!-- Select All or Place holder for the link used to redirect the user to the record in a different tab -->
        <th scope="col" *ngIf="selectable || showGoToRecordColumn || sortMode === SortMode.Dragging">
          <!-- Checkbox to select all rows -->

          <ng-container *ngIf="selectable && (hasEDPWriteAccess$ | async)">
            <miq-tableHeaderCheckbox
              [disabled]="disabledSelection || disableHeaderCheckbox"
              class="complex-table-header-chck"
              [ngClass]="{ 'complex-table-header-chck--disabled': disabledSelection }"
            ></miq-tableHeaderCheckbox>
          </ng-container>
        </th>

        <ng-container *ngFor="let col of columns">
          <ng-container
            *ngIf="
              sortable && sortMode === SortMode.Default && (col?.sortable || col?.options?.sortable);
              else nonSortable
            "
          >
            <!-- sortable column mode -->
            <th scope="col" [style.width]="col?.width" [pSortableColumn]="col.field">
              <span>
                {{ col?.header }}
                <ng-container *ngIf="showRequiredIconTableHeader && col.required"
                  ><span class="required"> &#x2a; </span>
                </ng-container></span
              >
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          </ng-container>
          <!-- non sortable column mode -->
          <ng-template #nonSortable>
            <th scope="col" [style.width]="col?.width">
              <span>
                {{ col?.header }}
                <ng-container *ngIf="showRequiredIconTableHeader && col.required">
                  <span class="required"> &#x2a; </span>;
                </ng-container></span
              >
            </th>
          </ng-template>
        </ng-container>

        <th scope="col" *ngIf="!!childColumns">
          <!-- show details column -->
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
      <tr
        miq-complex-table-row
        [pReorderableRow]="rowIndex"
        [row]="rowData"
        [columns]="parentColumns"
        [pSelectableRow]="rowData"
        [expandable]="!!childColumns"
        [selectable]="selectable"
        [sortable]="sortable"
        [sortMode]="sortMode"
        [sortMessage]="sortMessage"
        [disableSelection]="disabledSelection || disableHeaderCheckbox"
        [expandedMessage]="expandedMessage"
        [nonExpandedMessage]="nonExpandedMessage"
        [showGoToRecordColumn]="showGoToRecordColumn"
        [rowLinkGenerator]="rowLinkGenerator"
        (toggle)="toggle($event)"
        (rowChange)="onChange($event)"
        (clearSelection)="clearSelectionAndCheckSelectionBlock()"
        [class]="rowData?.rowClass"
        [ngClass]="{
          clickableRow: clickableRow,
          nonClickableRow: !clickableRow,
          'complex-table-select-column-chck--disabled': disabledSelection,
        }"
        (click)="onParentRowClick(rowData)"
      ></tr>
      <tr *ngIf="rowData.expanded">
        <td [attr.colspan]="parentColumns.length + 2" class="subsection-table">
          <miq-child-table
            [tableService]="tableStateService"
            [selectable]="selectable && (hasEDPWriteAccess$ | async) ? selectableChild : false"
            [title]="childTitle"
            [elements]="rowData.children | hideFlaggedItems: hideChildElements"
            [selectedItems]="selectedChildResources"
            (selectedItemsChange)="selectedChildResourcesChange.emit($event)"
            [parent]="rowData"
            [columns]="childColumns"
            [commands]="childCommands"
            [notify]="notify"
            [disableSelection]="disabledSelection || disableHeaderCheckbox"
            (childChange)="onChildChange($event, rowData)"
            [clickableRow]="clickableRow"
            [class]="rowData?.rowClass"
            [showGoToRecordColumn]="childShowGoToRecordColumn"
            [rowLinkGenerator]="childRowLinkGenerator"
            [sortable]="sortable"
            [sortMode]="sortMode"
            [sortMessage]="sortMessage"
            (rowClick)="onChildRowClick($event)"
            (rowReorderEvent)="handleRowReorder($event, rowData)"
          >
          </miq-child-table>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="parentColumns.length + 2">
          {{
            'recordsSearch.noRecordElementsFound'
              | xTranslate: { elements: title || ('recordsSearch.elements' | xTranslate) | lowercase }
          }}.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
